import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Skeleton = ({ className }) => (
  <div className={cx('skeleton-line', className)} />
);

Skeleton.propTypes = {
  className: PropTypes.string,
};

export default Skeleton;
